import { render, staticRenderFns } from "./radio-button-input.vue?vue&type=template&id=31fc3d5e&"
import script from "./radio-button-input.vue?vue&type=script&lang=js&"
export * from "./radio-button-input.vue?vue&type=script&lang=js&"
import style0 from "./radio-button-input.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports